import React, { useState, useEffect } from 'react';
import {
  Modal,
  Button,
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { getErrorMessage } from '../../../../../utils/helper';
import {
  getSuperAdminOrderDetailsUrl,
} from '../../../../../services/endpoints/orders';

import AlertComponent from '../../../../../components/Alert';
import Loader from '../../../../../components/Loaders/Loader';
import Spinner from '../../../../../components/Loaders/Spinner';

const OrderDetailsSuperAdminModal = ({ data, onHide }) => {
  const [error, setError] = useState(null);
  const [isLoading] = useState(false);
  const [modalData, setModalData] = useState({
    init: false,
    success: false,
    error: null,
    details: [],
  })
  const { init, details, success } = modalData;

  const fetchData = async () => {
    try {
      const response = await getSuperAdminOrderDetailsUrl(data.id);
      if (response?.data) {
        setModalData((prevState) => ({
          ...prevState,
          init: true,
          details: response.data,
          resendOrder: data?.access?.resend_order || false,
        }));
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setModalData((prevState) => ({
        ...prevState,
        init: true,
      }))
      setError(errorMessage);
    }
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? <Loader success={success} /> : null}
        {error ? <AlertComponent text={error} type="danger" /> : null}
        {init ? (
          <>
            {details?.map((detail, index) => {
              if (detail.fieldKey === 'content' && isEmpty(detail.value)) return null;

              return (
                <FormGroup key={index}>
                  {detail.label && <ControlLabel>{detail.label}</ControlLabel>}
                  <FormControl rows={7} componentClass={detail.type} name={detail.name} readOnly value={detail.value} />
                </FormGroup>
              )
            })}
          </>
        ) : <Spinner />}
      </Modal.Body>
      <Modal.Footer className="custom__modal-footer">
        <Button
          disabled={isLoading}
          onClick={onHide}
        >
          Close
        </Button>
      </Modal.Footer>
    </>
  );
};

OrderDetailsSuperAdminModal.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onHide: PropTypes.func,
};

export default OrderDetailsSuperAdminModal;
